'use client'

import { Button, Card, CardContent, CardFooter, CardHeader, cn } from "@heroui/react"
import { useRouter } from 'next/navigation'
import { Icon } from '../ui/icon'

interface UnifiedErrorProps {
  error: Error
  reset?: () => void
  className?: string
  title?: string
  message?: string
  variant?: 'default' | 'warning' | 'error'
  icon?: string
}

export function UnifiedError({
  error,
  reset,
  className,
  title = 'An Error Occurred',
  message,
  variant = 'default',
  icon = 'danger-triangle'

}: UnifiedErrorProps) {
  const router = useRouter()

  // Fallback message if no specific one is provided
  const displayedMessage = message || error.message || 'An unknown error occurred'

  return (
    <Card className={cn("overflow-visible relative border-small border-danger-100 bg-danger-50/10", className)}>
      <CardHeader>
        <div className="flex items-center gap-3">
          <Icon
            icon={icon as any}
            className="w-6 h-6 text-danger"
          />
          <p className="font-medium text-large text-danger">{title}</p>
        </div>
      </CardHeader>
      <CardContent className="px-3">
        <div className="flex flex-col gap-2 px-2">
          <p className="font-medium text-large text-foreground/80">
            {displayedMessage}
          </p>
          <p className="text-small text-foreground/60">
            Please try again or contact support if the issue persists.
          </p>
        </div>
      </CardContent>
      <CardFooter className="justify-end gap-2">
        <div className="flex w-full gap-2">
          {reset && (
            <Button
              fullWidth
              variant="ghost"
              onPress={reset}
            >
              Try Again
            </Button>
          )}
          <Button
            fullWidth
            variant="ghost"
            onPress={() => router.push('/')}
          >
            Return Home
          </Button>
        </div>
      </CardFooter>
    </Card>
  )
}
